import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import { toast } from "react-toastify";

function ProtectedRoute({ allowedRoles }) {
  const { token, role, status } = useSelector((state) => state.auth);
  const hasShownToast = useRef(false);

  useEffect(() => {
    if (status === "loading") return;

    if (!token && !hasShownToast.current) {
      toast.error("Session expired. Please log in again.");
      hasShownToast.current = true;
    } else if (token && allowedRoles && !allowedRoles.includes(role) && !hasShownToast.current) {
      toast.error("Not authorized to access this page.");
      hasShownToast.current = true;
    }
  }, [status, token, role, allowedRoles]);

  if (status === "loading") return null; 

  if (!token) return <Navigate to="/" replace />;
  if (allowedRoles && !allowedRoles.includes(role)) return <Navigate to="/unauthorized" replace />;

  return <Outlet />;
}

export default ProtectedRoute;